import { render, staticRenderFns } from "./ModelPresetsManage.vue?vue&type=template&id=237d2313&"
import script from "./ModelPresetsManage.vue?vue&type=script&lang=js&"
export * from "./ModelPresetsManage.vue?vue&type=script&lang=js&"
import style0 from "./ModelPresetsManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports